import { EnvironmentProviders, inject, makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';

import { SPLASH_SCREEN_OPTIONS, SplashScreenOptions } from './splash-screen.options';
import { SplashScreenService } from './splash-screen.service';

/**
 * Provides and eagerly starts the {@link SplashScreenService}, which removes the
 * static boot splash from index.html after the first router navigation completes.
 *
 * @param options.transientRoutes Route URL prefixes that should NOT trigger splash
 *   removal (e.g. `['/oidc-login-callback']`). Defaults to an empty list.
 */
export function provideSplashScreen(options: SplashScreenOptions = {}): EnvironmentProviders {
  return makeEnvironmentProviders([
    SplashScreenService,
    {
      provide: SPLASH_SCREEN_OPTIONS,
      useValue: { transientRoutes: options.transientRoutes ?? [] },
    },
    provideEnvironmentInitializer(() => inject(SplashScreenService)),
  ]);
}
